// This is the same regular expression used by se-web-api to validate email addresses
export const EMAIL_REGEXP = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
